import React, { useState } from "react";

const VgStarRating = (props) => {
  const [rating, setRating] = useState(props.rating);
  const [hover, setHover] = useState(0);
  return (
    <div className="vg-star-rating">
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={index <= (hover || rating) ? "on v-filled-star" : "off"}
            onClick={() => {props.setRating(index); setRating(index); setHover(index)}}
            onMouseEnter={() =>  rating < index ? setHover(index): ""}
            onMouseLeave={() => setHover(rating)}
          >
            <span className={index <= (hover || rating) ? "star v-filled-star" : "star"}></span>
          </button>
        );
      })}
    </div>
  );
};

export default VgStarRating;